import React, { FC } from "react";
import Head from "next/head";
import { baseUrl } from "services/shared/Environment";
import Script from "next/script";

export const NewsMediaOrganizationSchema: FC = () => {
  const schema = JSON.stringify({
    "@context": "http://schema.org",
    "@type": "NewsMediaOrganization",
    name: "The Juggernaut",
    logo: {
      "@context": "http://schema.org",
      "@type": "ImageObject",
      url: `${baseUrl()}/static/wordmark_logo.png`,
      height: 25,
      width: 100,
    },
    url: "https://www.thejuggernaut.com/",
    ethicsPolicy: "https://www.thejuggernaut.com/ethics",
    foundingDate: "2019-02-15",
    sameAs: [
      "https://www.instagram.com/_thejuggernaut/?hl=en",
      "https://twitter.com/bethejuggernaut",
      "https://www.facebook.com/bethejuggernaut/",
      "https://www.linkedin.com/company/thejuggernaut",
    ],
  });
  return (
    <Head>
      <Script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: schema,
        }}
      />
    </Head>
  );
};
